var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"error","title":_vm.title,"sub-title":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }